export interface NewsArticle {
  id: string;
  title: string;
  summary: string;
  category: '最新' | '热点' | '专题';
  author: string;
  date: string;
  cover: string;
  content: string[];
}

export const newsCategories = ['全部', '最新', '热点', '专题'];

export const newsList: NewsArticle[] = [
  {
    id: 'n1',
    title: '2026国庆档票房前瞻：多部大片齐聚，科幻与悬疑成最大看点',
    summary:
      '今年国庆档共有十余部新片定档，科幻、悬疑、合家欢题材形成三足鼎立之势，业内预测档期总票房有望再创新高。',
    category: '热点',
    author: '红桃影视编辑部',
    date: '2026-10-11',
    cover:
      'https://readdy.ai/api/search-image?query=Widescreen%20cinema%20lobby%20with%20glowing%20red%20and%20orange%20movie%20poster%20light%20boxes%2C%20festive%20blockbuster%20atmosphere%2C%20stylized%20illustration%2C%20no%20text&width=1200&height=675&seq=htv-news-n1&orientation=landscape',
    content: [
      '随着国庆假期临近，2026年国庆档的竞争格局逐渐清晰。据不完全统计，目前已有超过十二部影片正式定档，涵盖科幻、悬疑、喜剧、动画等多个类型，成为近年来类型最为丰富的一个档期。',
      '从目前的热度数据来看，科幻巨制《星际远征》与悬疑片《深渊回响》位列想看人数前两位，两者分别代表了工业大片与作者电影两条不同的路线，也构成了今年档期最有意思的对话。',
      '业内人士分析认为，国庆档历来是全年票房的重要节点。今年多部影片在视效与叙事上都有明显升级，加上观众观影习惯的逐步回归，档期整体表现值得期待。',
      '红桃影视将持续关注各片的口碑与票房走势，为观众提供及时的资讯与深度解析。',
    ],
  },
  {
    id: 'n2',
    title: '《星际远征》口碑爆棚，被视为华语科幻新标杆',
    summary:
      '影片上映首周便收获高分口碑，宏大的世界观与扎实的情感内核成为观众讨论焦点。',
    category: '最新',
    author: '影视观察员 林一',
    date: '2026-10-10',
    cover:
      'https://readdy.ai/api/search-image?query=Widescreen%20deep%20space%20scene%20with%20a%20lone%20spaceship%20before%20a%20crimson%20nebula%2C%20epic%20cinematic%20mood%2C%20stylized%20digital%20artwork%2C%20no%20text&width=1200&height=675&seq=htv-news-n2&orientation=landscape',
    content: [
      '《星际远征》自上映以来，凭借扎实的剧本与出色的视效赢得了大量好评。许多观众表示，影片在宏大叙事之外，对人物情感的刻画同样细腻动人。',
      '导演陈默在采访中提到，团队花了三年时间打磨世界观设定，希望让每一个技术细节都经得起推敲，同时又不会让观众感到疏离。',
      '影评人普遍认为，《星际远征》的出现，标志着华语科幻在类型化道路上又迈出了坚实的一步。',
    ],
  },
  {
    id: 'n3',
    title: '剧集《刑侦档案》收视持续走高，真实感成最大亮点',
    summary:
      '该剧摒弃浮夸套路，以扎实的案件推理和群像塑造获得观众认可，连续多周占据热度榜前列。',
    category: '热点',
    author: '红桃影视编辑部',
    date: '2026-10-09',
    cover:
      'https://readdy.ai/api/search-image?query=Widescreen%20moody%20detective%20office%20with%20a%20dim%20lamp%20and%20case%20files%2C%20dark%20tones%20with%20crimson%20accent%2C%20cinematic%20mood%2C%20stylized%20illustration%2C%20no%20text&width=1200&height=675&seq=htv-news-n3&orientation=landscape',
    content: [
      '作为今年口碑最稳的悬疑剧之一，《刑侦档案》没有依赖夸张的反转，而是把重心放在案件逻辑与人物关系上，这让整部剧的质感格外扎实。',
      '剧中重案组的每一位成员都有清晰的性格与背景，群像戏份的处理获得不少好评。有观众评论说，看这部剧像在读一本严谨的纪实录。',
      '随着剧情进入中后段，主线悬念逐渐收紧，社交平台上的讨论热度也随之攀升。',
    ],
  },
  {
    id: 'n4',
    title: '年度盘点：2026年上半年值得一看的高分影视推荐',
    summary:
      '从科幻到现实主义题材，我们梳理了上半年口碑与热度俱佳的一批作品，供你按图索骥。',
    category: '专题',
    author: '专题组',
    date: '2026-10-08',
    cover:
      'https://readdy.ai/api/search-image?query=Widescreen%20grid%20of%20glowing%20movie%20screens%20in%20a%20dark%20room%2C%20warm%20orange%20and%20red%20glow%2C%20curated%20collection%20mood%2C%20stylized%20illustration%2C%20no%20text&width=1200&height=675&seq=htv-news-n4&orientation=landscape',
    content: [
      '一年过半，我们回头盘点了上半年表现亮眼的影视作品。既有工业水准出众的科幻大片，也有聚焦普通人生活的现实主义剧集。',
      '值得一提的是，今年高质量的中小成本作品明显增多，创作者在类型融合与叙事实验上都表现出更强的信心。',
      '这份片单按照类型与口碑整理，希望能帮你快速找到合口味的那一部。',
    ],
  },
  {
    id: 'n5',
    title: '专访《归途列车》导演：我想拍一部关于“慢”的电影',
    summary:
      '在快节奏的时代，导演贾樟柯分享了创作这部横穿大陆的公路电影的初衷与幕后故事。',
    category: '人物',
    author: '特约记者 苏晚',
    date: '2026-10-07',
    cover:
      'https://readdy.ai/api/search-image?query=Widescreen%20empty%20train%20carriage%20interior%20at%20dusk%20with%20warm%20light%20through%20windows%2C%20contemplative%20cinematic%20mood%2C%20stylized%20illustration%2C%20no%20text&width=1200&height=675&seq=htv-news-n5&orientation=landscape',
    content: [
      '谈及《归途列车》的创作灵感，导演表示，这一切都要从一次历时三天的长途旅行说起。在那趟列车上，他遇到了形形色色的人，也听到了许多平凡却动人的故事。',
      '“我想拍一部关于‘慢’的电影，”他说，“在这个什么都讲究效率的时代，愿意停下来听别人说话，本身就是一种珍贵。”',
      '影片上映后获得了观众与评论界的双重肯定，被认为是近年来最具人文温度的国产剧情片之一。',
    ],
  },
  {
    id: 'n6',
    title: '韩国悬疑片《深渊回响》为何刷屏？三个关键词解读',
    summary:
      '封闭空间、心理压迫与声音叙事，这部作品用极简的形式讲出了强烈的张力。',
    category: '热点',
    author: '影视观察员 林一',
    date: '2026-10-06',
    cover:
      'https://readdy.ai/api/search-image?query=Widescreen%20dark%20submarine%20corridor%20with%20a%20single%20red%20emergency%20glow%2C%20claustrophobic%20tense%20mood%2C%20stylized%20illustration%2C%20no%20text&width=1200&height=675&seq=htv-news-n6&orientation=landscape',
    content: [
      '《深渊回响》几乎全部情节都发生在深海科研站这一封闭空间内，却凭借层层递进的悬念牢牢抓住了观众。',
      '导演对声音的运用极为讲究，许多关键信息并非通过画面，而是通过细微的声效传递给观众，这种设计让紧张感始终处于高位。',
      '影片对人性在极端环境下的表现也做了颇有深度的探讨，这也让它在同类型作品中显得格外耐人回味。',
    ],
  },
  {
    id: 'n7',
    title: '武侠剧集体回归，古装市场迎来新一轮变局',
    summary:
      '多部武侠新剧陆续上线，传统题材正以更现代的叙事和视听语言重新赢得年轻观众。',
    category: '专题',
    author: '专题组',
    date: '2026-10-05',
    cover:
      'https://readdy.ai/api/search-image?query=Widescreen%20misty%20bamboo%20forest%20with%20a%20distant%20swordsman%20silhouette%20and%20falling%20petals%2C%20crimson%20light%20accents%2C%20wuxia%20cinematic%20mood%2C%20stylized%20illustration%2C%20no%20text&width=1200&height=675&seq=htv-news-n7&orientation=landscape',
    content: [
      '沉寂数年后，武侠题材在今年迎来明显回暖。《江湖笔录》等新剧的热播，让这一经典类型重新回到大众视野。',
      '与早年的武侠剧相比，新作品在动作设计与世界观构建上更加考究，同时在情感线上也更贴近当代观众的审美。',
      '有评论认为，武侠的回归不只是情怀，更是创作者在传统与创新之间找到平衡的结果。',
    ],
  },
  {
    id: 'n8',
    title: 'AI 技术如何改变影视制作？一线从业者的几点观察',
    summary:
      '从分镜预演到后期特效，人工智能正在渗透影视工业的各个环节，效率与创造力都在被重新定义。',
    category: '最新',
    author: '技术观察 方哲',
    date: '2026-10-04',
    cover:
      'https://readdy.ai/api/search-image?query=Widescreen%20futuristic%20editing%20suite%20with%20glowing%20orange%20interface%20panels%20and%20film%20frames%2C%20dark%20high%20tech%20mood%2C%20stylized%20illustration%2C%20no%20text&width=1200&height=675&seq=htv-news-n8&orientation=landscape',
    content: [
      '过去一年，AI 工具在影视制作流程中的存在感显著提升，尤其在前期概念设计与后期效率环节，已经有不少团队将其纳入常规工作流。',
      '不过受访的从业者也强调，技术终究是辅助，讲好一个故事仍然是影视创作的核心。',
      '如何在提升效率的同时保留创作的独特性，成为行业共同面对的新课题。',
    ],
  },
  {
    id: 'n9',
    title: '经典翻拍潮再起：是致敬情怀，还是缺乏原创？',
    summary:
      '越来越多经典作品被重新搬上荧幕，翻拍究竟是市场选择还是创作惰性，引发广泛讨论。',
    category: '专题',
    author: '特约记者 苏晚',
    date: '2026-10-03',
    cover:
      'https://readdy.ai/api/search-image?query=Widescreen%20vintage%20film%20projector%20casting%20warm%20light%20in%20a%20dark%20theater%2C%20nostalgic%20cinematic%20mood%2C%20stylized%20illustration%2C%20no%20text&width=1200&height=675&seq=htv-news-n9&orientation=landscape',
    content: [
      '翻拍经典并非新鲜事，但近期翻拍项目的密集程度依然引发了不小的讨论。支持者认为这是对经典的重新解读，反对者则担心会消解原创的动力。',
      '事实上，成功的翻拍往往不是简单复刻，而是找到了与当下观众对话的新角度。',
      '无论立场如何，观众最终会用脚投票，市场也会给出答案。',
    ],
  },
  {
    id: 'n10',
    title: '暑期档剧集观察：现实主义题材为何持续走红',
    summary:
      '贴近生活的故事与真实可感的人物，成为观众追剧的重要理由。',
    category: '最新',
    author: '红桃影视编辑部',
    date: '2026-10-02',
    cover:
      'https://readdy.ai/api/search-image?query=Widescreen%20modern%20city%20apartment%20windows%20glowing%20warm%20at%20night%2C%20everyday%20life%20mood%20with%20amber%20tones%2C%20stylized%20illustration%2C%20no%20text&width=1200&height=675&seq=htv-news-n10&orientation=landscape',
    content: [
      '纵观今年的剧集市场，现实主义题材无疑是最稳定的一股力量。它们或许没有炫目的特效，却凭借真实的人物与情感打动了观众。',
      '从都市职场到家庭生活，这类作品把镜头对准普通人，反而收获了强烈的共鸣。',
      '可以预见，在追求共情的当下，真诚的创作仍将是观众最买账的选择。',
    ],
  },
];